import axios from 'axios';

const ROOT = 'api/v1/ai';
const HIDE_LOADER = { hideLoader: true };

const AiAnalyticsApi = {
  getThreads() {
    return axios.get(`${ROOT}/threads`, HIDE_LOADER);
  },
  getThread(threadId) {
    return axios.get(`${ROOT}/threads/${threadId}`, HIDE_LOADER);
  },
  createThread(title) {
    return axios.post(`${ROOT}/threads`, { title }, HIDE_LOADER);
  },
  updateThread(threadId, patch) {
    return axios.patch(`${ROOT}/threads/${threadId}`, patch, HIDE_LOADER);
  },
  deleteThread(threadId) {
    return axios.delete(`${ROOT}/threads/${threadId}`, HIDE_LOADER);
  },

  askQuestion(threadId, payload) {
    return axios.post(`${ROOT}/threads/${threadId}/asks`, payload, HIDE_LOADER);
  },
  pollAskResult(queryId) {
    return axios.get(`${ROOT}/asks/${queryId}`, HIDE_LOADER);
  },
  getActiveAsk(threadId) {
    return axios.get(`${ROOT}/threads/${threadId}/asks/active`, HIDE_LOADER);
  },
  getActiveOperations() {
    return axios.get(`${ROOT}/operations/active`, HIDE_LOADER);
  },

  getSemanticModel() {
    return axios.get(`${ROOT}/admin/schema/embeddings`, HIDE_LOADER);
  },
  updateSemanticRow(id, text) {
    return axios.patch(`${ROOT}/admin/schema/embeddings/${id}`, { text }, HIDE_LOADER);
  },
  createExampleQuery({ question, sql, description }) {
    return axios.post(`${ROOT}/admin/schema/example-queries`, { question, sql, description }, HIDE_LOADER);
  },
  updateExampleQuery(id, { question, sql, description }) {
    return axios.patch(`${ROOT}/admin/schema/example-queries/${id}`, { question, sql, description }, HIDE_LOADER);
  },
  deploySchema() {
    return axios.post(`${ROOT}/admin/schema/deployments`, {}, HIDE_LOADER);
  },

  previewData(messageId) {
    return axios.post(`${ROOT}/messages/${messageId}`, null, HIDE_LOADER);
  },
  refreshMessageData(messageId) {
    return axios.put(`${ROOT}/messages/${messageId}`, null, HIDE_LOADER);
  },
  saveMessageChartSpec(messageId, chartSpec) {
    return axios.put(`${ROOT}/messages/${messageId}/chart-spec`, { chartSpec }, HIDE_LOADER);
  },
  rateMessage(messageId, payload) {
    return axios.put(`${ROOT}/messages/${messageId}/feedback`, payload, HIDE_LOADER);
  },
  removeMessageFeedback(messageId) {
    return axios.delete(`${ROOT}/messages/${messageId}/feedback`, HIDE_LOADER);
  },

  generateChart(messageId, question) {
    return axios.post(`${ROOT}/messages/${messageId}/charts`, question ? { question } : {}, HIDE_LOADER);
  },
  refineChart(messageId, instruction) {
    return axios.post(`${ROOT}/messages/${messageId}/chart-refinements`, { instruction }, HIDE_LOADER);
  },
  pollChartResult(queryId) {
    return axios.get(`${ROOT}/charts/tasks/${queryId}`, HIDE_LOADER);
  },

  getCharts() {
    return axios.get(`${ROOT}/charts`, HIDE_LOADER);
  },
  saveChart(data) {
    return axios.post(`${ROOT}/charts`, data, HIDE_LOADER);
  },
  updateChart(chartId, patch) {
    return axios.put(`${ROOT}/charts/${chartId}`, patch, HIDE_LOADER);
  },
  regenerateChart(chartId, type) {
    return axios.post(`${ROOT}/charts/${chartId}/spec`, { type }, HIDE_LOADER);
  },
  deleteChart(chartId) {
    return axios.delete(`${ROOT}/charts/${chartId}`, HIDE_LOADER);
  },
  refreshChartData(chartId) {
    return axios.put(`${ROOT}/charts/${chartId}/data`, null, HIDE_LOADER);
  },

  getInstructions() {
    return axios.get(`${ROOT}/instructions`, HIDE_LOADER);
  },
  createInstruction(payload) {
    return axios.post(`${ROOT}/instructions`, payload, HIDE_LOADER);
  },
  updateInstruction(instructionId, payload) {
    return axios.put(`${ROOT}/instructions/${instructionId}`, payload, HIDE_LOADER);
  },
  deleteInstruction(instructionId) {
    return axios.delete(`${ROOT}/instructions/${instructionId}`, HIDE_LOADER);
  },
  createGlobalInstruction(payload) {
    return axios.post(`${ROOT}/admin/instructions`, payload, HIDE_LOADER);
  },
  updateGlobalInstruction(instructionId, payload) {
    return axios.put(`${ROOT}/admin/instructions/${instructionId}`, payload, HIDE_LOADER);
  },
  deleteGlobalInstruction(instructionId) {
    return axios.delete(`${ROOT}/admin/instructions/${instructionId}`, HIDE_LOADER);
  }
};

export default AiAnalyticsApi;
